import { Box, Typography, makeStyles } from "@material-ui/core";
import { orderSupport } from "./orderSupport.constants";

export const OrderSupport = ({ data = orderSupport }: { data?: any }) => {
  const classes = OrderSupportStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.title} color="#160337">
        What happens <span className={classes.next}>next</span>
      </Box>
      <Box className={classes.subTitle}>Your customer success manager will ring you regarding the following</Box>
      <Box className={classes.wrapper}>
        {data.map((item: any, index: any) => {
          return (
            <Box width={270} key={index}>
              <img src={item.src} alt="text" width={100} height={100} />
              <Typography className={classes.content}>{item.content}</Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

const OrderSupportStyles = makeStyles((theme) => ({
  container: {
    textAlign: "center",
    width: 970,
    margin: "auto",
    fontFamily: "Axiforma, serif, sans-serf !important",
    [theme.breakpoints.down("sm")]: {
      width: 350,
      fontFamily: "Axiforma, serif, sans-serf !important"
    }
  },
  wrapper: {
    display: "flex",
    justifyContent: "space-around",
    [theme.breakpoints.down("sm")]: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  },
  next: {
    color: "#f7815c"
  },
  title: {
    fontSize: 28,
    fontWeight: 500,
    marginBottom: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: 20,
      marginBottom: 15
    }
  },
  subTitle: {
    fontSize: 16,
    marginBottom: 92,
    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
      marginBottom: 72
    }
  },
  content: {
    fontSize: 16,
    marginTop: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
      marginBottom: 60
    }
  }
}));
